export default __webpack_public_path__ + "static/media/chaqueta-explorador-mujer.7629b48a.png";